<template>
  <div v-if="!isMobile" class="flex flex-1 h-10 items-center">
    <Swiper
      ref="swiperRef"
      :settings="settings"
      :modules="[Autoplay, Pagination]"
      :pagination="{
        clickable: true,
        el: '.swiper-pagination1',
        enabled: !isMobile,
      }"
      class="h-full !mx-0 !relative"
      @mouseenter.native="onMouseEnter"
      @mouseleave.native="onMouseLeave"
    >
      <SwiperSlide v-for="(item, index) in shuffledGames" :key="index" class="u-center">
        <div class="u-center">
          <OImage
            loading="lazy"
            :src="item === 'emojile' ? '/images/game/EmojileLogo.png' : '/images/game/BilpopLogo.png'"
            class="w-[90px] h-[34.50px] ml-1"
          />
          <div class="text-right text-white text-sm mx-[10px]">Günün Sorusu</div>
          <!-- Emojile -->
          <div v-if="item === 'emojile'">
            <div
              v-if="games.emojile"
              class="h-10 w-[307px] flex bg-gradient-to-b from-[#00084d] to-[#2c4389] pr-3 py-1 justify-between items-center"
            >
              <div class="u-center w-[211px] pl-2 h-10 border-l-2 border-r-2 border-[#5E73DC]">
                <div v-for="(i, idx) in games.emojile.question" :key="idx" class="u-center">
                  <div class="icon-border text-20 leading-12 u-center p-4 w-8 h-8">{{ i.emoji }}</div>
                  <span v-if="idx < games.emojile.question.length - 1" class="text-md font-normal mx-0.5 text-[#B2C0FF]">+</span>
                </div>
                <div v-if="games.emojile.question.length < 3" class="u-center">
                  <span class="text-md font-normal mx-0.5 text-[#B2C0FF]">=</span>
                  <div class="icon-border text-20 text-white leading-12 u-center p-4 w-8 h-8">?</div>
                </div>
              </div>
              <OButton pure class="text-white text-[13px] font-semibold ml-3" href="/emojile">Şimdi Oyna</OButton>
            </div>
          </div>
          <!-- Bilpop -->
          <div v-else>
            <div class="h-10 w-[307px] pr-3 bg-gradient-to-b from-[#400577] to-[#6d2fbf] justify-center items-center gap-3 inline-flex">
              <div class="w-[211px] h-10 px-3 py-2 border-l-2 border-r-2 border-[#e98523] justify-center items-center gap-2.5 flex">
                <div v-if="games.bilpop" class="text-[#ff9513] text-xs font-medium line-clamp-2">
                  {{ games.bilpop.question }}
                </div>
              </div>
              <OButton pure class="text-white text-[13px] font-semibold" href="/bilpop">Şimdi Oyna</OButton>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div class="swiper-pagination1 px-2"></div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { Autoplay, Pagination } from 'swiper';
import { useDevice } from '~/composables/useDevice';
import Swiper from '~/modules/sliders/core/Swiper.vue';
import SwiperSlide from '~/modules/sliders/core/SwiperSlide.vue';
import { OButton, OImage, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon, OImage, Swiper, SwiperSlide, OButton },

  props: { games: { type: Object, required: true } },

  setup(props, { emit }) {
    const { isMobile } = useDevice();

    const swiperRef = ref();

    const gamesList = ['bilpop', 'emojile'];
    const shuffledGames = computed(() => {
      return gamesList.sort(() => Math.random() - 0.5);
    });

    const onMouseEnter = () => {
      swiperRef.value.swiperEl.swiper.autoplay.pause();
      emit('onMouseEnter');
    };
    const onMouseLeave = () => {
      swiperRef.value.swiperEl.swiper.autoplay.run();
      emit('onMouseLeave');
    };

    const settings = computed(() => ({
      direction: 'vertical',
      speed: 150,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    }));

    return { isMobile, Autoplay, Pagination, settings, swiperRef, onMouseEnter, onMouseLeave, shuffledGames };
  },
});
</script>
<style scoped>
.icon-border {
  border-radius: 3.491px;
  border: 0.582px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0px 0px 6.982px 0px rgba(0, 0, 0, 0.05);
}
.soru {
  flex-shrink: 0;
  border-radius: 4.465px;
  border: 0.744px solid rgba(255, 255, 255, 0.35);
  box-shadow: 0px 0px 8.93px 0px rgba(0, 0, 0, 0.05);
}
.swiper-pagination1 {
  display: grid;
  gap: 8px;
  position: relative;
  left: 0;
  transform: none;
  width: unset;
}
</style>
